/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    if (feature.getSettingValue('ENABLED').toString() === '0') {
        return blocks;
    }
    const SNTP_SERVER = feature.getSettingValue('SNTP_SERVER');
    const DEBUGGING = feature.getSettingValue('DEBUGPRINT');

    const { project } = feature;
    const INTERFACE = 'current_interface';

    blocks.push({
        location: 'IMPORTS',
        blockType: BlockType.CODE,
        template: 'import ntptime',
    });

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `ntptime.host = ${SNTP_SERVER}`,
    });

    if (DEBUGGING === '1') {
        blocks.push({
            location: 'VARIABLE_DECLARATIONS',
            blockType: BlockType.CODE,
            template: 'ntptime.debug = True',
        });
    }


    blocks.push({
        location: project.getNetworkConnectedLocation('current_interface'),
        blockType: BlockType.CODE,
        template: `
min_offset = td_get_tzone_offset(APP_TIMEZONE)
ntptime.settime(min_offset)`,
    });
    return blocks;
};
